import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import RBPopover from 'react-bootstrap/Popover';

import cx from 'classnames';

const Popover = ({
  children,
  content = {},
  placement = "bottom",
  display = 'd-inline-block',
  reverse = false,
  customClass = null,
  title = ''
}) => {
  
  const renderPopover = (props) => (
    <RBPopover
      {...props}
      className={cx(`custom-popover ${customClass}`, {reverse: reverse})}
    >
      <RBPopover.Body>
        {typeof content === 'function' ? content() : content}
      </RBPopover.Body>
    </RBPopover>
  );

  return (
    <OverlayTrigger
      overlay={renderPopover}
      trigger={['hover', 'focus']}
      placement={placement}
    >
      <div className={display}>{children}</div>
    </OverlayTrigger>
  );
}

export default Popover;
